<template>
    <div id="owner-panel">
        <customModalSidebar :settings="customSidebarSettings"></customModalSidebar>
        <div class="owner-panel-container">
            <div v-if="!pageLoad" class="page-spinner">
                <b-spinner style="width: 3rem; height: 3rem;" type="grow" label="Spinning"></b-spinner>
                <span v-if="organization == null">{{translate('own_anyConnectedPlace')}}</span>
            </div>
            <div v-if="pageLoad">
                <div class="owner-panel">
                    <div class="owner-header">
                        <router-link :to="{name: 'OwnerPlaceManagement'}" class="logo">
                            <img src="@/assets/landing/logo.svg" alt="AirVote Logo">
                        </router-link>
                        <div class="nav">
                            <div class="lang-switcher" @click="openLangSwitcher" v-if="this.$route.name == 'ProfileSettings'">
                                <div class="lang-switcher__icon">
                                    <i v-if="this.langSwitcherDropdown == false" class="fas fa-caret-right"></i>
                                    <i v-else class="fas fa-caret-down"></i>
                                </div>
                                <div class="lang-switcher__text">
                                    {{this.langSelect}}
                                </div>
<!--                                <languageSwitcher></languageSwitcher>-->
                            </div>
                            <div v-if="userInfo.is_verified == false">
                                <div class="email-confirm__content" @click="pushToSettings">
                                    <div class="email-confirm__icon">
                                        <img src="@/assets/icons/ic_exclamation.svg">
                                    </div>
                                    <div class="email-confirm__text">{{translate('own_email_Confim')}}</div>
                                </div>
                            </div>
                            <transition name="fade" appear>
                                <div class="lang-switcher__dropdown" id="lang-switcher__dropdown" v-if="this.langSwitcherDropdown">
                                    <div class="switcher-dropdown__wrapper">
                                        <ul class="switcher-dropdown__list" @click="changeLanguage">
                                            <li v-for="(lang) in $ml.list" :key="lang"
                                                v-text="lang"
                                                @click="$ml.change(lang)"
                                                class="switcher-dropdown__item">
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </transition>
                            <div class="profile-content">
                                <div class="profile-photo">
                                    <div class="email-confirm__wrapper">
                                        <div @click="pushToSettings">
                                            <img src="@/assets/icons/ic_account_cog.svg" alt="Profile photo">
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="question-mark__wrapper plus" @click="callHelpCenter" v-if="renderClass == 'desktop'">
                                <img src="@/assets/icons/ic_question_mark.svg">
                            </div>
                            <div v-else class="question-mark__wrapper" :class="{show: isDashboard}" @click="moreOptionsSiteBarClick">
                                <img src="@/assets/icons/ic_add.svg">
                            </div>

                        </div>
                    </div>
                </div>
                <router-view></router-view>
            </div>
        </div>
    </div>

</template>

<script>

import {mapActions, mapGetters, mapMutations, mapState} from 'vuex';
    import customModalSidebar from '@/components/widgets/customModalSidebar';
    import MenuBar from '@/components/widgets/menuBar';
    import errorMixin from '@/mixins/errorMixin';
    import logAnalyticsEvent, {logError} from '@/helpers/analytics'
    import $ from 'jquery'

    export default {
        mixin: [errorMixin, mixin],
        data() {
            return {
                pageLoad: true,
                customSidebarSettings: {},
                langShow: false,
                langSelect: this.$ml.current,
                langSwitcherDropdown: false,
                renderClass: 'desktop',
            }
        },

        components: {
            MenuBar,
            customModalSidebar,
        },

        computed: {
            ...mapState({
                userInfo: state => state.auth.userInfo,
            }),
            ...mapGetters({
                isUserAdmin: 'auth/isUserAdmin',
                isUserClient: 'auth/isUserClient',
                isUserDriver: "auth/isUserDriver",
                getOrgUid: 'auth/getOrgUid',
            }),
            isDashboard() {
                console.log(this.$route.name)
                return this.$route.name === 'OwnerPlaceManagement'
            }
        },
        beforeMount() {
            if(this.getOrgUid == null) {
                console.log(`org uid = null`)
                if(this.isUserAdmin) {
                    this.$router.push({name: 'adminPanel'})
                } else if(this.isUserDriver) {
                    this.$router.push({name: 'driverFlow'})
                } else if(this.isUserClient) {
                    this.$router.push({name: 'noacc'})
                }
            }
        },
        mounted() {
            this.setLanguage(this.$ml.current)
            this.renderClass = window.innerWidth > 1000 ? 'desktop' : 'mobile'
        },
        methods: {
            ...mapMutations({
                setLanguage: 'setLanguage',
                setSiteListDropdown: 'owner/setSiteListDropdown',
                setSideBarToggle: 'owner/setSideBarToggle',
            }),
            ...mapActions({
                updateProfileLang: 'profiles/updateProfileLang',
                logUserAction: 'owner/logUserAction',
            }),

            callHelpCenter() {
                this.customSidebarSettings = {
                    title: this.translate('helpCenterTitle'),
                    helpCenter: true
                }
                this.logAction('click_help_center')
            },
            pushToSettings() {
                this.logAction('click_settings')
                this.$router.push('/settings')
            },
            openLangSwitcher() {
                this.langSwitcherDropdown = !this.langSwitcherDropdown
                let thiz = this
                if(this.langSwitcherDropdown) {
                    $(document).one('mouseup', function (e) {
                        let wrapper = $(".lang-switcher__dropdown")
                        if (wrapper != e.target && wrapper.has(e.target).length === 0){
                            thiz.openLangSwitcher()
                        }
                    });
                }
            },
            changeLanguage() {
                logAnalyticsEvent('lang_click', {
                    lang: this.$ml.current,
                    source: this.$route.name === 'Login' ? 'sign_in' : 'drawer'
                })
                this.langSelect = this.$ml.current;
                this.setLanguage(this.$ml.current)
                this.langSwitcherDropdown = false
                this.updateLanguage()
            },
            moreOptionsSiteBarClick() {
                this.setSideBarToggle(true)
            },
            async updateLanguage () {
                const response = await this.updateProfileLang(localStorage.getItem('lang'))
            },
            logAction(action) {
                try {
                    this.logUserAction({ action: action})
                } catch (e) {}
            },
        }

    }

</script>

<style>
    .email-confirm__wrapper {
        position: relative;
    }
    .email-confirm__content {
        display: flex;
        width: max-content;
        text-align: center;
        align-items: center;
        border-radius: 12px;
        background-color: #FFBF00;
        padding: 5px 8px;
        cursor: pointer;
    }
    .email-confirm__icon {
        margin-right: 10px;
        padding-bottom: 3px;
    }

    .email-confirm__text {
        color: #2F2F2F;
        font-family: Montserrat;
        font-size: 12px;
        font-weight: 500;
        letter-spacing: 0;
        line-height: 15px;
    }
    .question-mark__wrapper {
        margin-left: 18px;
        cursor: pointer;
        display: none;
    }
    .question-mark__wrapper.plus {
        display: block;
    }
    .question-mark__wrapper.show {
        display: block;
    }
    .profile-content {
        display: flex;
        flex-direction: column;
        align-items: flex-end;
    }
    .profile-photo {
        cursor: pointer;
    }
    .profile-photo__wrapper {
        position: relative;
        cursor: pointer;
    }
    .fade-enter-active,
    .fade-leave-active {
        transition: all .5s ease-out;
    }
    .fade-enter,
    .fade-leave-to {
        opacity: 0;
    }
    .profile-photo__dropdown {
        position: fixed;
        top: 95px;
        z-index: 999;
        background-color: #FFFFFF;
        box-shadow: 0px 2px 14px rgba(0, 0, 0, 0.106042);
        border-radius: 4px;
    }
    .lang-switcher {
        position: relative;
        cursor: pointer;
        margin-right: 32px;
        text-align: right;
        text-transform: uppercase;
        display: flex;
        align-items: center;
        flex-direction: row-reverse;
    }
    .lang-switcher__dropdown {
        position: fixed;
        z-index: 10;
        top: 90px;
        width: 56px;
        background: #FFFFFF;
        box-shadow: 0px 2px 14px rgba(0, 0, 0, 0.106042);
        border-radius: 4px;
        padding: 12px 16px 12px 18px;
    }
    .lang-switcher__dropdown::-webkit-scrollbar {
        display: none;
    }
    .lang-switcher__icon {
        margin-left: 10px;
        width: 8px;
    }
    .switcher-dropdown__list {
        display: flex;
        flex-direction: column;
        margin-bottom: 0;
    }
    .switcher-dropdown__item {
        margin: 0 0 24px;
        font-style: normal;
        font-weight: bold;
        font-size: 16px;
        line-height: 24px;
        color: #3F405C;
        text-transform: uppercase;
        cursor: pointer;
    }
    .switcher-dropdown__item:last-child{
        margin-bottom: 0;
    }

    @media screen and (max-width: 1281px) {
        .email-confirm__content {
            top: 60px;
            right: 0px;
        }
    }
    @media screen and (max-width: 1000px) {
        .profile-photo__dropdown {
            top: 70px;
        }
        .lang-switcher__dropdown {
            top: 63px;
        }
    }

    @media screen and (max-width: 769px) {
        .email-confirm__text {
            width: 200px;
        }
    }

    @media screen and (max-width: 426px) {
        .email-confirm__content {
            display: none;
        }
    }

</style>
<style scoped>
    .profile-photo {
        height: 40px;
        width: 40px;
        border-radius: 5px;
    }
    .profile-photo img {
        border-radius: 0 !important;
    }
</style>
